// extracted by mini-css-extract-plugin
export default {"container":"ListingDetails_container__cGCxD","loadingContainer":"ListingDetails_loadingContainer__J5+Bm"};